export interface ApiErrorItem {
  message: string;
  field?: string;
  code?: string;
}

export interface Pagination {
  total: number;
  offset?: number;
  limit?: number;
}

export interface PaginatedResult<T> {
  items: T[];
  pagination: Pagination;
  /**
   * Aggregates over the whole filtered set, when the endpoint sends them.
   *
   * The till and the expense book do: a total that only adds up the twenty
   * rows on screen answers a question nobody asked. Everything else omits it.
   */
  totals?: Record<string, number>;
}

export class ApiError extends Error {
  status: number;
  errors: ApiErrorItem[];
  requestId: string;

  constructor(status: number, message: string, errors: ApiErrorItem[], requestId: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.errors = errors;
    this.requestId = requestId;
  }
}
